(function() {
    angular
        .module("globalArrowBoardMapModule")
        .controller("globalArrowBoardMapController", globalArrowBoardMapController)

        globalArrowBoardMapController.$inject = [
        "$rootScope",
        "$scope",
        "$state",
        "prefs",
        "devicesService",
        "googleMapsService",
    ]

    function globalArrowBoardMapController(
        $rootScope,
        $scope,
        $state,
        prefs,
        devicesService,
        googleMapsService,
    ){
        "use strict"


        $rootScope.title = "Deployed Arrow Boards | WANCO"

        $scope.loading = true

        $scope.showLabels    = prefs.get().devices.showMapLabels
        $scope.showClusters  = prefs.get().devices.showMapClusters
        $scope.devices            = []
        $scope.quantityOfArrowBoards = 0

        let map = undefined

        const handleMap = (forceNewMap) => {
            if (map === undefined || forceNewMap) {
                googleMapsService.createMap("mapConstruct").then((mapObject) => {
                    map = mapObject
                    googleMapsService.setMarkers(true, map, $scope.devices, $scope.showLabels, $scope.showClusters)
                })

            } else {
                googleMapsService.setMarkers(false, map, $scope.devices, $scope.showLabels, $scope.showClusters)
            }
        }

        $scope.toggleLabels = () => {

            $scope.showLabels = !$scope.showLabels
            googleMapsService.toggleMarkerLabels()
            prefs.set(prefs.selectors().devices.showMapLabels, $scope.showLabels)

        }

        $scope.toggleClusters = () => {
            $scope.showClusters = !$scope.showClusters
            prefs.set(prefs.selectors().devices.showMapClusters, $scope.showClusters)
            handleMap()

        }

        devicesService.getDeployedArrowBoards((categorized) => {

            $scope.devices = categorized.all
            $scope.quantityOfArrowBoards = devicesService.getTotalDevices()
            handleMap(true)
            $scope.loading = false
        })


    }
})()
